<template>
  <van-sticky>
    <van-nav-bar
      :style="{ paddingTop: statusHeight + 'px' }"
      :title="title"
      :left-text="leftText"
      :right-text="rightText"
      :left-arrow="leftArrow"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left v-if="leftArrow">
        <img
          class="backIcon"
          src="../assets/images/back.png"
          alt=""
        />
      </template>
    </van-nav-bar>
  </van-sticky>
</template>

<script>
import http from "../utils/http.js";
export default {
  name: "commonHead",
  data() {
    return {};
  },
  // 接受父组件的值
  props: {
      
    title: {
      // 标题
      type: String,
      default: "",
    },
    leftText: {
      // 返回按钮文本
      type: String,
      default: "",
    },
    leftArrow: {
      // 返回按钮是否显示
      type: Boolean,
      default: true,
    },
    rightText: {
      //右侧按钮文本
      type: String,
      default: "",
    },
    rightIconName: {
      //右侧按钮文本
      type: String,
      default: "",
    },
    isShare: {
      type: Boolean,
      default: false,
    },
    backNative: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.maxDate = new Date();
  },
  computed: {
    statusHeight() {
      return this.$store.state.statusHeight;
    },
  },
  methods: {
    //点击左侧按钮
    onClickLeft() {
      if (this.backNative) {
        http.guitarAppListener("backToNative", {});
      } else {
        //    this.$router.go(-1)
        history.back();
        //    if(title=='自学课'){
        this.$store.commit("Set_refresh", true);
        //    }
      }
    },
    //点击右侧按钮
    onClickRight() {},
  },
};
</script>

<style lang="less" scoped>
.backIcon {
  width: 22px;
  height: 22px;
}
// .van-nav-bar {
//   .van-nav-bar__left {
//     .van-icon {
//       color: #000000;
//       font-size: 18px;
//     }
//   }
.van-nav-bar {
  /deep/ .van-nav-bar__left {
    height: 46px !important;
    bottom: 0 !important;
    top: auto !important;
    .van-icon {
      color: #000000;
      font-size: 18px;
    }
  }
  //   .van-nav-bar__right {
  //     .van-icon {
  //       color: #333333;
  //       font-size: 20px;
  //     }
  //     .van-nav-bar__text {
  //       color: #333333;
  //       font-size: 18px;
  //     }
  //   }
  /deep/ .van-nav-bar__right {
    height: 46px !important;
    bottom: 0 !important;
    top: auto !important;
    .van-icon {
      color: #333333;
      font-size: 20px;
    }
    .van-nav-bar__text {
      color: #333333;
      font-size: 18px;
    }
  }
  /deep/ .van-nav-bar__title {
    font-size: 18px !important;
    color: #222030;
  }
}
</style>